/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'prettyPrintPercentage',
    standalone: false
})
export class PrettyPrintPercentagePipe implements PipeTransform {

    transform(percentage: number, fixed?: number): string {
        let percentagePrettify = null;
        if (percentage != null) {
            if (fixed != null) {
                percentagePrettify = `${percentage.toFixed(fixed)}%`;
            } else {
                percentagePrettify = `${percentage}%`;
            }
        }
        return percentagePrettify;
    }
}
